import React from "react"
import LeftSideBar from "./leftsidebar"
import Header from "./header"
import FirstRunTour from "../../components/onboarding/FirstRunTour"
import { usePersistedState } from "../../hooks/usePersistedState"

const SIDEBAR_OPEN_STORAGE_KEY = "mis.ui.sidebarOpen"

export const Layout = ({ children }) => {
  const [open, setOpen] = usePersistedState(SIDEBAR_OPEN_STORAGE_KEY, true)
  const drawerClick = () => {
    setOpen((prev) => !prev)
  }
  return (
    <section className={`main-area${open ? "" : " sidebar-collapsed"}`}>
      <LeftSideBar open={open} onExpand={() => setOpen(true)} />
      <div className="right-bar">
        <Header drawerClick={drawerClick} sidebarOpen={open} />
        {children}
        <FirstRunTour />
      </div>
    </section>
  )
}
